import { createAsyncThunk } from '@reduxjs/toolkit';
import * as groupApi from '../../api/groupsapi';

export const getGroups = createAsyncThunk('getGroupList', async (data) => {
    const res = await groupApi.getGroupList({ data: data });
    return res.data;
});

export const deleteGroup = createAsyncThunk('deleteGroup', async (data) => {
    const res = await groupApi.deleteGroup({ data: data });
    return res.data;
});

export const saveGroup = createAsyncThunk('saveGroup', async (data) => {
    const res = await groupApi.saveEditGroup({ data: data });
    return res.data;
});

export const editGroup = createAsyncThunk('editGroup', async (data) => {
    const res = await groupApi.saveEditGroup({ data: data });
    return res.data;
});

export const getPatientGroupsById = createAsyncThunk('getPatientGroupsById', async (data) => {
    const res = await groupApi.getPatientGroupById({ data: data });
    return res.data;
});

export const deleteFromGroupByPatientid = createAsyncThunk('deletePatientFromGroupById', async (data) => {
    const res = await groupApi.deletePatientFromGroupById({ data: data });
    return res.data;
});

export const getPatientList = createAsyncThunk('getPatientList', async (data) => {
    const res = await groupApi.getPatientList({ data: data });
    return res.data;
});

export const getContactList = createAsyncThunk('getContactList', async (data) => {
    const res = await groupApi.getContactList({ data: data });
    return res.data;
});